import { createSlice } from "@reduxjs/toolkit";
import HomeAPIs from "api/Home/home";
import { requests } from 'api/index';
import URLS  from 'api/endPoints';


// Slice

const initiaHomestate = {
  BILLBOARD: "", FEATUREDJOB: "", GROUPS: "", GETGROUPRELATEDJOBID: "", HOMEBANNER: "", GETPROGRAMMING: "", CHECKITV:"", EMPLOYEE: "",KNOWUSMORE:"",TEAMICICIPOST:"", GETMOREJOBS:"",GETITV: "",PREVIEWJOB:"",GETALLCOURSE:"",GET_RELATED_PORTFOLIOS:""
}

const slice = createSlice({
  name: "Home",
  initialState: {
    home: initiaHomestate,
  },
  reducers: {
    GetBillboard: (state, action) => {
      state.home.BILLBOARD = action.payload;
    },
    GetFeaturedJob: (state, action) => {
      state.home.FEATUREDJOB = action.payload;
    },
    Groups: (state, action) => {
      state.home.GROUPS = action.payload;
    },
    getGroupRelatedJobId: (state, action) => {
      // action.payload.map((val, index) => {
      state.home.GETGROUPRELATEDJOBID = action.payload;
      // })
    },

    getHomeBanner: (state, action) => {
      state.home.HOMEBANNER = action.payload;
    },
    getProgramming: (state, action) => {
      state.home.GETPROGRAMMING = action.payload;
    },
    CheckITV: (state, action) => {
     
      state.home.CHECKITV = action.payload;
    },
    getEmployee: (state, action) => {
     
      state.home.EMPLOYEE = action.payload;
    },
    getKnowUsMore: (state, action) => {
      state.home.KNOWUSMORE = action.payload;
    },
    getITV: (state, action) => {
      state.home.GETITV = action.payload;
    },
     CheckITV: (state, action) => {
  
    state.home.CHECKITV = action.payload
    },
     
    getTeamICICI: (state, action) => {
    
      state.home.TEAMICICIPOST = action.payload
    },
    getMoreJobScroll: (state, action) => {
    
      state.home.GETMOREJOBS = action.payload
    },
    getPreviewJob: (state, action) => {
      state.home.PREVIEWJOB = action.payload
    },
    getAllCourses: (state, action) => {
    
      state.home.GETALLCOURSE = action.payload
    },
    getRelatedPortfolios: (state, action) => {
    
      state.home.GET_RELATED_PORTFOLIOS = action.payload
    },
    
    
  },
});

export default slice.reducer;

// Actions

const { GetBillboard,GetFeaturedJob,Groups, getGroupRelatedJobId,getHomeBanner,getProgramming, CheckITV,getKnowUsMore,getTeamICICI,getMoreJobScroll,getITV,getPreviewJob,getAllCourses,getRelatedPortfolios } = slice.actions
export const getBillboardAction = (user) => async dispatch => {
    try {
    let response= await HomeAPIs.getBillboard();
    // console.log(response, "from billboard");
    await dispatch(GetBillboard(response));
    return await returnCode(response);
  } catch (e) {
    return console.error(e.message);
  }
};

export const getFeaturedJobAction = (user) => async (dispatch) => {
  try {
    let response = await HomeAPIs.getFeaturedJob();
    // console.log(response.Data, "from getfeaturedapi")
    if(response.ResponseCode==100){
    await dispatch(GetFeaturedJob(response));
  }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const groupsAction = () => async (dispatch) => {
  try {
    let response = await HomeAPIs.groups();
    if(response.ResponseCode==100){
    await dispatch(Groups(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};

export const getHomeBannerAction = () => async (dispatch) => {
  try {
    let response = await HomeAPIs.getBanner();
    await dispatch(getHomeBanner(response));
    if(response.ResponseCode==100){
    return await returnCode(response);
    }
  } catch (error) {
    return console.error(error.message);
  }
};

export const getGroupRelatedJobIdAction = (id) => async (dispatch) => {
  try {
    let response = await HomeAPIs.getGroupRelatedJob(id);
    if(response.ResponseCode==100){
    await dispatch(getGroupRelatedJobId(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};

export const getProgrammingAction = () => async (dispatch) => {
  try {
    let response = await HomeAPIs.portfolio();
    if(response.ResponseCode==100){
    await dispatch(getProgramming(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};


export const getPreviewJobAction = (payload) => async (dispatch) => {
  
  try {
  
    let response = await requests.get(URLS.magUrl.portfolioPreview + payload.id)
    if(response.ResponseCode==100){
     await dispatch(getPreviewJob(response))
    }

    return await returnCode(response)

  } catch (error) {

    return console.error(error.message)
    
  }
}

export const getCheckITVAction = () => async (dispatch) => {
  try {
    let response = await HomeAPIs.getITV()
    if(response.ResponseCode==100){
    await dispatch(CheckITV(response))
    }
    return await returnCode(response)
  } catch (error) {
    return console.error(error.message);
  }
};

export const getknowUsMoreAction = () => async (dispatch) => {
  try {
    let response = await HomeAPIs.knowUsMore();
    if(response.ResponseCode==100){
    await dispatch(getKnowUsMore(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
}
export const getRelatedPortfoliosByIDAction =(payload)=> async (dispatch) =>{
  try {
    let response = await HomeAPIs.getRelatedPortfoliosByID(payload);
    if(response.ResponseCode==100){
    await dispatch(getRelatedPortfolios(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
}
export const getTeamiciciAction = () => async dispatch => {
  try {
    let response = await HomeAPIs.getTeamICICI()
 
    await dispatch(getTeamICICI(response))
    return await returnCode(response)
  } catch (error) {
     return console.error(error.message)
  }
}

export const getMoreJobsOnScrollAction = (payload) => async dispatch => {
  try {
    
    let response = await HomeAPIs.getMoreJob(payload)
    if(response.ResponseCode==100){
    await dispatch(getMoreJobScroll(response))
    }
    return await returnCode(response)
  } catch (error) {
     return console.error(error.message)
  }
}
export const  GetAllCourseAction = () => async dispatch => {
  try {
    
    let response = await HomeAPIs.getAllCourse();
    if(response.ResponseCode==100){
    await dispatch(getAllCourses(response));
    }
    return await returnCode(response)
  } catch (error) {
     return console.error(error.message)
  }
}


export const getITVAction = () => async (dispatch)=>{
  try {
    let response = await HomeAPIs.getITV();
    // console.log("from action"+response)
    if(response.ResponseCode==100){
    await dispatch(getITV(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
}

function returnCode(response) {
  if (response.ResponseCode == 100 || 200) {
    return response;
  } else if (response.ResponseCode == 103) {
    return 103;
  } else {
    return 101;
  }
}
